export type ReviewSource = 'WEBSITE' | 'FACEBOOK' | 'INSTAGRAM' | 'VIBER' | 'OTHER';

export interface Review {
    id: number;
    productId: number | null;
    productName?: string | null;
    productSlug?: string | null;
    authorName: string;
    city: string | null;
    rating: number;
    text: string;
    source: ReviewSource;
    verifiedPurchase: boolean;
    createdAt: string;
}

export interface ReviewSummary {
    count: number;
    average: number;
    reviews: Review[];
}

export interface NewReview {
    productId: number | null;
    authorName: string;
    city: string | null;
    rating: number;
    text: string;
    phoneNumber: string | null;
    /** Hidden field - only bots fill it in. */
    website: string;
}

export interface AdminReview {
    id?: number;
    productId: number | null;
    authorName: string;
    city: string | null;
    rating: number;
    text: string;
    phoneNumber: string | null;
    source: ReviewSource;
    verifiedPurchase: boolean;
    approved: boolean;
    createdAt: string | null;
}

/** Shown next to a review; reviews written on this site need no label. */
export const REVIEW_SOURCE_LABELS: Record<ReviewSource, string> = {
    WEBSITE: '',
    FACEBOOK: 'од Facebook',
    INSTAGRAM: 'од Instagram',
    VIBER: 'од Viber',
    OTHER: ''
};

/** 4.75 -> "4,8", the way ratings are written in Macedonian. */
export function formatRating(value: number): string {
    return value.toFixed(1).replace('.', ',');
}

export function reviewCountLabel(count: number): string {
    return `${count} ${count === 1 ? 'мислење' : 'мислења'}`;
}
